import React, { useRef } from 'react'
import { InputNumber } from 'primereact/inputnumber'

export default function LtsInputNumber(props) {
  const { label, value, onChange, id, inputId, onBlur, inputProps: inputPropsProp, ...restProps } = props

  const parseNumericValue = (raw) => {
    if (raw == null) return null
    if (typeof raw === 'number' && !Number.isNaN(raw)) return raw
    const str = String(raw).trim()
    if (!str) return null

    const compact = str.replace(/\s/g, '').replace(/[^0-9,.-]/g, '')
    if (!compact) return null

    const negative = compact.startsWith('-')
    const lastComma = compact.lastIndexOf(',')
    const lastDot = compact.lastIndexOf('.')
    const decimalIndex = Math.max(lastComma, lastDot)
    const hasComma = lastComma >= 0
    const hasDot = lastDot >= 0
    const maxFractionDigits = Number.isInteger(restProps.maxFractionDigits) ? restProps.maxFractionDigits : null

    let integerPart = compact
    let fractionPart = ''
    if (decimalIndex > 0 && decimalIndex < compact.length - 1) {
      const candidateInteger = compact.substring(0, decimalIndex)
      const candidateFraction = compact.substring(decimalIndex + 1)
      const fractionDigitsOnly = candidateFraction.replace(/[^0-9]/g, '')

      // If only one separator type is present and there are exactly 3 trailing digits,
      // treat it as thousands separator for integer fields.
      const singleSeparatorType = (hasComma && !hasDot) || (!hasComma && hasDot)
      const shouldTreatAsThousands =
        singleSeparatorType &&
        fractionDigitsOnly.length === 3 &&
        (maxFractionDigits === null || maxFractionDigits === 0)

      if (!shouldTreatAsThousands) {
        integerPart = candidateInteger
        fractionPart = candidateFraction
      }
    }

    const integerDigits = integerPart.replace(/[^0-9]/g, '')
    const fractionDigits = fractionPart.replace(/[^0-9]/g, '')
    const normalized = `${negative ? '-' : ''}${integerDigits}${fractionDigits ? `.${fractionDigits}` : ''}`

    if (!normalized || normalized === '-') return null
    const n = Number(normalized)
    return Number.isNaN(n) ? null : n
  }

  const fallbackIdRef = useRef(null)
  if (!fallbackIdRef.current) {
    fallbackIdRef.current = `lts-input-number-${Math.random().toString(36).slice(2, 10)}`
  }

  const resolvedId = inputId ?? id ?? fallbackIdRef.current
  const resolvedValue = value == null ? null : value

  return (
    <span className="p-float-label">
      <InputNumber
        {...restProps}
        inputId={resolvedId}
        value={resolvedValue}
        allowEmpty={restProps.allowEmpty ?? true}
        onValueChange={(e) => onChange?.(e.value)}
        onChange={(e) => onChange?.(e.value)}
        onBlur={(e) => {
          const parsed = parseNumericValue(e?.target?.value)
          const current = typeof value === 'number' && !Number.isNaN(value) ? value : null
          if (parsed !== current) onChange?.(parsed)
          onBlur?.(e)
        }}
        inputProps={{
          ...(inputPropsProp || {}),
          autoComplete: (inputPropsProp && inputPropsProp.autoComplete) || 'off',
        }}
      />
      {label ? <label htmlFor={resolvedId}>{label}</label> : null}
    </span>
  )
}
